// extracted by mini-css-extract-plugin
module.exports = {"decor":"styles_decor__Z7Fiq","icon":"styles_icon__14y3s"};